import { c as _c } from "react/compiler-runtime";
import { DropInteractionParams } from "@/components/waves/drops/Drop";
import { ApiNotificationCause } from "@/generated/models/ApiNotificationCause";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { TypedNotification } from "@/types/feed.types";
import { memo } from "react";
import NotificationAllDrops from "./all-drops/NotificationAllDrops";
import NotificationDropQuoted from "./drop-quoted/NotificationDropQuoted";
import NotificationDropReplied from "./drop-replied/NotificationDropReplied";
import NotificationIdentityMentioned from "./identity-mentioned/NotificationIdentityMentioned";
import NotificationIdentitySubscribed from "./identity-subscribed/NotificationIdentitySubscribed";
import NotificationPriorityAlert from "./priority-alert/NotificationPriorityAlert";
import NotificationWaveCreated from "./wave-created/NotificationWaveCreated";
import type { JSX } from "react";
import NotificationDropReacted from "./drop-reacted/NotificationDropReacted";
function NotificationItemComponent(t0) {
  const $ = _c(9);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  let t1;
  if ($[0] !== activeDrop || $[1] !== notification || $[2] !== onDropContentClick || $[3] !== onQuote || $[4] !== onReply) {
    t1 = () => {
      switch (notification.cause) {
        case ApiNotificationCause.DropQuoted:
          {
            return <NotificationDropQuoted notification={notification} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
          }
        case ApiNotificationCause.DropReplied:
          {
            return <NotificationDropReplied notification={notification} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
          }
        case ApiNotificationCause.DropVoted:
        case ApiNotificationCause.DropReacted:
          {
            return <NotificationDropReacted notification={notification} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
          }
        case ApiNotificationCause.IdentityMentioned:
          {
            return <NotificationIdentityMentioned notification={notification} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
          }
        case ApiNotificationCause.IdentitySubscribed:
          {
            return <NotificationIdentitySubscribed notification={notification} />;
          }
        case ApiNotificationCause.WaveCreated:
          {
            return <NotificationWaveCreated notification={notification} />;
          }
        case ApiNotificationCause.AllDrops:
          {
            return <NotificationAllDrops notification={notification} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
          }
        case ApiNotificationCause.PriorityAlert:
          {
            return <NotificationPriorityAlert notification={notification} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
          }
        default:
          {
            assertUnreachable(notification);
            return <div />;
          }
      }
    };
    $[0] = activeDrop;
    $[1] = notification;
    $[2] = onDropContentClick;
    $[3] = onQuote;
    $[4] = onReply;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const getComponent = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-relative lg:tw-hidden"><div className="tw-h-full tw-w-[1px] tw-bg-iron-800 -tw-translate-x-8" /></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== getComponent) {
    t3 = <div className="tw-flex">{t2}<div className="tw-w-full">{getComponent()}</div></div>;
    $[7] = getComponent;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
const NotificationItem = memo(NotificationItemComponent);
NotificationItem.displayName = "NotificationItem";
export default NotificationItem;